/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotModelFeatureMetric extends models.CopilotMetricActivityBase {
    getFixupPrototypeFunction() { return CopilotModelFeatureMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotModelFeatureMetric>): CopilotModelFeatureMetric {
        let obj = Object.assign(new CopilotModelFeatureMetric(), model);
        CopilotModelFeatureMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotModelFeatureMetric>): CopilotModelFeatureMetric {
        if (!model) return null;
        return CopilotModelFeatureMetric.newInstance(<CopilotModelFeatureMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotModelFeatureMetric) {
        if (!obj) return;

        models.CopilotModelFeatureMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotModelFeatureMetric): boolean {
        if (models.CopilotMetricActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotModelFeatureMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Feature name (e.g. code_completion, agent_edit)
     */
    feature: string;

    /**
     * AI model name (e.g. gpt-4.1, claude-4.0-sonnet)
     */
    name: string;

}
